import React from 'react';
import {useFilterDatesContext} from "../Context/FilterDatesContext";
import {MDBCol, MDBRow} from "mdb-react-ui-kit";
import {Button} from "semantic-ui-react";

export default function DateFields() {
    const {dates, setDates, errors} = useFilterDatesContext();

    const handleDateChange = (e, field, type) => {
        setDates({
            ...dates,
            [field]: {...dates[field], [type]: e.target.value},
        });
        // localStorage.setItem('dates', JSON.stringify(dates));
    };

    const toggleField = (field) => {
        setDates({
            ...dates,
            [field]: {...dates[field], enabled: !dates[field].enabled},
        });
    };

    const resetDates = () => {
        const dates = JSON.parse(localStorage.getItem('defaultDates'))
        setDates({
            depart: {enabled: true, start: dates.depart.start, end: dates.depart.end},
            creation: {enabled: true, start: dates.creation.start, end: dates.creation.end},
            ajoutFacturation: {enabled: false, start: dates.ajoutFacturation.start, end: dates.ajoutFacturation.end}
        });
    };

    return (
        <div>
            <MDBRow className="d-flex justify-content-center">

                <MDBCol lg={12} md={12} xs={12}
                        className="d-lg-flex d-md-flex justify-content-lg-end justify-content-center pe-0"
                        style={{backgroundColor: dates.depart.enabled ? 'white' : '#f6edfd', margin: '3px', padding : '3px', borderRadius:'5px'}}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <input
                            type="checkbox"
                            checked={dates.depart.enabled}
                            onChange={() => toggleField('depart')}
                            style={{marginRight: '8px'}}
                        />
                        <label style={{minWidth: "80px", width: 'clamp(80px, 80px, 80px)'}}>Départ</label>
                    </div>
                    <input
                        type="date"
                        value={dates.depart.start}
                        onChange={(e) => handleDateChange(e, 'depart', 'start')}
                        disabled={!dates.depart.enabled}
                        style={{marginRight: '8px'}}
                    />
                    <span style={{marginRight: '8px'}}>à</span>
                    <input
                        type="date"
                        value={dates.depart.end}
                        onChange={(e) => handleDateChange(e, 'depart', 'end')}
                        disabled={!dates.depart.enabled}
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow className="d-flex justify-content-md-center">
                <MDBCol lg={12} md={12} xs={12}
                        className="d-lg-flex d-md-flex justify-content-lg-end justify-content-center pe-0"
                        style={{backgroundColor: dates.creation.enabled ? 'white' : '#f6edfd', margin: '3px', padding : '3px', borderRadius:'5px'}}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <input
                            type="checkbox"
                            checked={dates.creation.enabled}
                            onChange={() => toggleField('creation')}
                            style={{marginRight: '8px'}}
                        />
                        <label style={{minWidth: "80px", width: 'clamp(80px, 10vw, 80px)'}}>Création</label>
                    </div>
                    <input
                        type="date"
                        value={dates.creation.start}
                        onChange={(e) => handleDateChange(e, 'creation', 'start')}
                        disabled={!dates.creation.enabled}
                        style={{marginRight: '8px'}}
                    />
                    <span style={{marginRight: '8px'}}>à</span>
                    <input
                        type="date"
                        value={dates.creation.end}
                        onChange={(e) => handleDateChange(e, 'creation', 'end')}
                        disabled={!dates.creation.enabled}
                    />
                </MDBCol>
            </MDBRow>

            <MDBRow className="d-flex justify-content-md-center">
                <MDBCol lg={12} md={12} xs={12}
                        className="d-lg-flex d-md-flex justify-content-lg-end justify-content-center pe-0"
                        style={{
                            backgroundColor: dates.ajoutFacturation.enabled ? 'white' : '#f6edfd',
                            margin: '3px',
                            padding: '3px',
                            borderRadius: '5px'
                        }}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <input
                            type="checkbox"
                            checked={dates.ajoutFacturation.enabled}
                            onChange={() => toggleField('ajoutFacturation')}
                            style={{marginRight: '8px'}}
                        />
                        <label style={{minWidth: "80px", width: 'clamp(80px, 10vw, 80px)'}}>Facturation</label>
                    </div>
                    <input
                        type="date"
                        value={dates.ajoutFacturation.start}
                        onChange={(e) => handleDateChange(e, 'ajoutFacturation', 'start')}
                        disabled={!dates.ajoutFacturation.enabled}
                        style={{marginRight: '8px'}}
                    />
                    <span style={{marginRight: '8px'}}>à</span>
                    <input
                        type="date"
                        value={dates.ajoutFacturation.end}
                        onChange={(e) => handleDateChange(e, 'ajoutFacturation', 'end')}
                        disabled={!dates.ajoutFacturation.enabled}
                    />
                </MDBCol>
                <Button className={'btnResetDates'} onClick={resetDates}>
                    Réinitialiser les dates
                </Button>

            </MDBRow>

            <div className="text-danger">
                {errors.depart && <div>{errors.depart}</div>}
                {errors.creation && <div>{errors.creation}</div>}
                {errors.ajoutFacturation && <div>{errors.ajoutFacturation}</div>}
                {errors.general && <div>{errors.general}</div>}
            </div>
        </div>
    );
}
